import React from 'react';
import { useTranslation } from 'react-i18next';
import { StatusDot, type StatusTone } from '@redpanda/ui';
import { MapPinIcon } from '@heroicons/react/24/solid';

/**
 * 留言、許願卡片的第一行（兩頁共用，排版一致）：標題在左、色點標籤在右；置頂的留言在標題前加圖釘
 * 標籤：留言是類型（一般／意見回饋／Bug），許願是狀態（待評估／開發中／已完成／不採用）
 */
const PostHeading: React.FC<{ title: string; label: string; tone: StatusTone; pinned?: boolean }> = ({ title, label, tone, pinned }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
      <h2 className="text-base font-semibold text-fg break-words">
        {pinned && (
          <MapPinIcon className="mr-1.5 inline h-4 w-4 align-[-2px] text-amber-600 dark:text-amber-400" aria-label={t('pages.board.pinned')} />
        )}
        {title}
      </h2>
      <StatusDot tone={tone} label={label} />
    </div>
  );
};

export default PostHeading;
